import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "day-description" }
const _hoisted_4 = {
  id: "daily-rewards",
  class: "daily-rewards"
}
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "badges" }
const _hoisted_7 = { class: "badge" }
const _hoisted_8 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_9 = {
  key: 1,
  class: "text-capitalize-first"
}
const _hoisted_10 = { class: "rewards" }
const _hoisted_11 = { class: "reward-value" }
const _hoisted_12 = { class: "badge" }
const _hoisted_13 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_14 = {
  key: 1,
  class: "text-capitalize-first"
}
const _hoisted_15 = { class: "rewards" }
const _hoisted_16 = { class: "reward-value" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "reset-notice" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "wheel d-flex justify-content-center" }
const _hoisted_22 = {
  key: 2,
  class: "bonuses-section-appear"
}
const _hoisted_23 = { class: "d-flex flex-column align-items-center" }
const _hoisted_24 = { class: "bonuses" }
const _hoisted_25 = { class: "bonus-row" }
const _hoisted_26 = { class: "bonus-result" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "sub" }
const _hoisted_29 = { class: "coins" }
const _hoisted_30 = { class: "bonus-result" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = {
  key: 0,
  class: "sub"
}
const _hoisted_33 = {
  key: 1,
  class: "sub"
}
const _hoisted_34 = { class: "coins" }
const _hoisted_35 = { class: "description" }
const _hoisted_36 = { class: "bonus-row" }
const _hoisted_37 = { class: "bonus-result" }
const _hoisted_38 = { class: "title" }
const _hoisted_39 = { class: "sub" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "coins" }
const _hoisted_43 = { class: "bonus-result" }
const _hoisted_44 = { class: "title" }
const _hoisted_45 = { class: "sub" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "coins" }

import PopupWrapper from "@/components/PopupWrapper.vue";
import {computed, ref, watch, nextTick} from "vue";
import {reactive} from "@vue/reactivity";
import DailyBonusStateDTO from "@/models/DailyBonusStateDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";

interface DayDTO {
  num: number,
  percent?: number
  isClaimed: boolean,
  isCurrent: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WheelOfFortunePopup',
  setup(__props, { expose: __expose }) {

const state = reactive({
  currentAngle: 0 as number,
  bonusState: null as DailyBonusStateDTO|null,
  spinning: false as boolean,
  step: 0
})

const show = (bonusState: DailyBonusStateDTO) => {
  state.bonusState = bonusState
  popup.value?.show()
}

const hide = () => {
  popup.value?.hide()
}

__expose({ show, hide })

const rows = computed(() => {
  let items = [];
  for (const rows of [[1,2,3],[4,5,6],[7]]) {
    let dayItems = [];
    for (const dayNum of rows) {
      dayItems.push({
        num: dayNum,
        isClaimed: dayNum < (state.bonusState?.settings?.returnBonus.loginsCount ?? 0),
        isCurrent: dayNum === state.bonusState?.settings?.returnBonus.loginsCount,
        percent: state.bonusState?.settings?.returnBonus.percents[dayNum - 1]
      })
    }
    items.push(dayItems)
  }

  return items
})


const totalBonus = computed(() => {
  return state.bonusState?.settings?.totalBonus
})

const wheelBonus = computed(() => {
  return state.bonusState?.settings?.wheelBonus
})

const returnBonus = computed(() => {
  return state.bonusState?.settings?.returnBonus
})

const playBonus = computed(() => {
  return state.bonusState?.settings?.playBonus
})

const purchaseBonus = computed(() => {
  return state.bonusState?.settings?.purchaseBonus
})

const currentDay = computed((): DayDTO|null => {
  for (const days of rows.value) {
    for (const day of days) {
      if (!day.isCurrent) {
        continue;
      }

      return day;
    }
  }

  return null;
})

const popup = ref<InstanceType<typeof PopupWrapper> | null>(null)
const canvasRef = ref<InstanceType<typeof HTMLCanvasElement> | null>(null)
const wheelSectionRef = ref<HTMLElement | null>(null)
const collectBtnRef = ref<HTMLElement | null>(null)
const prizes = computed(() => {
  if (!state.bonusState?.settings) {
    return []
  }
  return state.bonusState?.settings?.wheelBonus.sums.map((item: any) => {
    return numberFormatter.formatNumber(item[1].amount)
  })
})

const winIndex = computed<number>((): number => {
  if (!state.bonusState?.settings) {
    return 0
  }

  for (const i in state.bonusState?.settings?.wheelBonus.sums) {
    const item = state.bonusState?.settings?.wheelBonus.sums[i] as any
    if (item[0] === state.bonusState?.settings?.wheelBonus.index) {
      return i as unknown as number;
    }
  }

  return 0;
})


const drawWheel = (canvas: HTMLCanvasElement, angle: any) => {
  if (!canvas) {
    return
  }

  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
  const numSectors = prizes.value.length;
  const arcSize = (2 * Math.PI) / numSectors;
  const cx = canvas.width / 2;
  const cy = canvas.height / 2;
  const radius = cx - 10;
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const fill2 = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
  fill2.addColorStop(0, '#373649');
  fill2.addColorStop(1, '#1b1a23');

  // Внешнее золотое кольцо
  ctx.beginPath();
  ctx.arc(cx, cy, radius, 0, 2 * Math.PI);
  ctx.fillStyle = fill2
  //ctx.fillStyle = '#292836';
  ctx.fill();


  ctx.beginPath();
  ctx.arc(cx, cy, radius - 15, 0, 2 * Math.PI);
  ctx.strokeStyle = '#525a7c';
  ctx.lineWidth = 3;
  ctx.stroke();

  // Секторы
  for (let i = 0; i < numSectors; i++) {
    const startAngle = angle + i * arcSize;
    const endAngle = startAngle + arcSize;
    const prize = prizes.value[i];

    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.arc(cx, cy, radius - 20, startAngle, endAngle);
    ctx.closePath();
    ctx.fillStyle = i % 2 === 0 ? '#5995ed' : '#ff3366';
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.arc(cx, cy, radius - 20, startAngle, endAngle);
    ctx.closePath();

    // Текст
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(startAngle + arcSize / 2);
    ctx.textAlign = 'right';
    ctx.font = '700 22px "Space Grotesk"';
    ctx.fillStyle = '#ffffff'
    //ctx.fillStyle = i % 2 === 0 ? '#5995ed' : '#ff3366';
    ctx.fillText(prize as string, radius - 35, 5);
    ctx.restore();
  }

  const fill = ctx.createRadialGradient(cx, cy, radius - 20, cx, cy, 0);
  fill.addColorStop(0, 'rgba(0,0,0,0.7)');
  fill.addColorStop(0.03, 'rgba(0,0,0,0)');
  fill.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.beginPath();
  ctx.arc(cx, cy, radius - 20, 0, 2 * Math.PI);
  ctx.fillStyle = fill
  ctx.fill();

  // Лампочки
  const diff = 7;
  const lampCount = prizes.value.length * 2;
  for (let i = 0; i < lampCount; i++) {
    if (i % 2 !== 0) {
      continue;
    }
    const a = (i / lampCount) * 2 * Math.PI;

    const lx = cx + (radius - diff) * Math.cos(a);
    const ly = cy + (radius - diff) * Math.sin(a);
    ctx.beginPath();
    ctx.arc(lx, ly, 4, 0, 2 * Math.PI);
    ctx.fillStyle = '#FFC857';
    ctx.fill();
  }


  // Центральное тёмное кольцо
  ctx.beginPath();
  ctx.arc(cx, cy, 30, 0, 2 * Math.PI);
  ctx.fillStyle = '#0d1520';
  ctx.fill();
  ctx.strokeStyle = '#333';
  ctx.lineWidth = 4;
  ctx.stroke();
}


let idleRafId: number | null = null

const startIdleSpin = () => {
  const speed = 0.003 // радиан за кадр — медленно
  const tick = () => {
    if (state.spinning) return // уступаем реальному спину
    state.currentAngle += speed
    drawWheel(canvasRef.value!, state.currentAngle)
    idleRafId = requestAnimationFrame(tick)
  }
  idleRafId = requestAnimationFrame(tick)
}

const stopIdleSpin = () => {
  if (idleRafId !== null) {
    cancelAnimationFrame(idleRafId)
    idleRafId = null
  }
}

watch(() => canvasRef.value, (newValue) => {
  if (newValue) {
    drawWheel(newValue, state.currentAngle)
    startIdleSpin()
  }
})

const store = useStore()
const claim = () => {
  api.call.bonuses.dailyClaim().then(async () => {
    await store.dispatch('updateUser');
  })
  hide()
}

const showReel = () => {
  state.step = 1
  wheelSectionRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  spin()
}

const spin = () => {
  if (state.spinning) return;
  state.spinning = true;
  stopIdleSpin()


  const arcSize = (2 * Math.PI) / prizes.value.length;

  const targetSectorAngle = -Math.PI / 2 - (winIndex.value * arcSize + arcSize / 2);
  const normalizedCurrent = state.currentAngle % (2 * Math.PI);
  let angleDiff = targetSectorAngle - normalizedCurrent;

  const extraSpins = 5 + Math.floor(Math.random() * 5);
  const targetAngle = state.currentAngle + (angleDiff % (2 * Math.PI)) + extraSpins * 2 * Math.PI;

  const duration = 4000;
  const startTime = performance.now();
  const startAngle = state.currentAngle;

  function easeInOut(t: number) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function animate(now: any) {
    const elapsed = now - startTime;
    const t = Math.min(elapsed / duration, 1);
    state.currentAngle = startAngle + (targetAngle - startAngle) * easeInOut(t);
    drawWheel(canvasRef.value!, state.currentAngle);

    if (t < 1) {
      requestAnimationFrame(animate);
    } else {
      state.spinning = false;
      state.step = 2
      nextTick(() => {
        collectBtnRef.value?.scrollIntoView({ behavior: 'smooth', block: 'end' })
      })
    }
  }

  requestAnimationFrame(animate);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrapper, {
    ref: (el) => popup.value = el,
    class: "wheel-of-fortune",
    "hide-close-btn": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(state).step >= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('wheel_of_fortune_title')), 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('wheel_of_fortune_day_number', {num: currentDay.value?.num ?? 1, count: 7})), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (days, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "rewards-row"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days, (day) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: day.num,
                        class: _normalizeClass([[day.num === 7 ? 'last-day' : '', day.isClaimed ? 'claimed' : '', day.isCurrent ? 'active' : ''], "reward-card"])
                      }, [
                        (day.num === 7)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[2] || (_cache[2] = _createElementVNode("img", {
                                class: "coin coin--large",
                                src: "/img/coins/gold_coin.svg",
                                alt: "coin"
                              }, null, -1)),
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/img/icons/star.svg" }, null, -1)),
                                    (day.isClaimed)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('claimed')), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('day_number', {num: day.num})), 1))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_11, "+" + _toDisplayString(_unref(numberFormatter).formatNumber(day.percent)) + "%", 1),
                                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "reward-label" }, "Free coins", -1))
                                  ])
                                ])
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_12, [
                                _cache[3] || (_cache[3] = _createElementVNode("img", { src: "/img/icons/star.svg" }, null, -1)),
                                (day.isClaimed)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('claimed')), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('day_number', {num: day.num})), 1))
                              ]),
                              _cache[5] || (_cache[5] = _createElementVNode("img", {
                                class: "coin",
                                src: "/img/coins/gold_coin.svg",
                                alt: "coin"
                              }, null, -1)),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_16, "+" + _toDisplayString(_unref(numberFormatter).formatNumber(day.percent)) + "%", 1),
                                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "reward-label" }, "Free coins", -1))
                                ])
                              ])
                            ], 64))
                      ], 2))
                    }), 128))
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('day_reset_notice')), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(showReel, ["prevent"]),
                      disabled: _unref(state).step !== 0,
                      class: "btn btn-primary btn-spin mb-2"
                    }, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('spin_reel')), 1)
                    ], 8, _hoisted_19)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(state).step >= 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              ref_key: "wheelSectionRef",
              ref: wheelSectionRef,
              class: "wheel-section-appear"
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-flex justify-content-center position-relative" }, [
                _createElementVNode("div", { class: "marker" })
              ], -1)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("canvas", {
                  ref: (el) => canvasRef.value = el,
                  id: "wheel",
                  width: "500",
                  height: "500"
                }, null, 512)
              ])
            ], 512))
          : _createCommentVNode("", true),
        (_unref(state).step >= 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wheel_of_fortune_total_bonus', {coins: _unref(numberFormatter).formatNumber(totalBonus.value?.amount)})), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('bonuses.spin_bonus')), 1),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t(`league.${wheelBonus.value?.league}`)), 1),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[7] || (_cache[7] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(wheelBonus.value?.winSum.amount)), 1)
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "description" }, " The higher your league, the bigger your bonuses on the wheel ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('bonuses.return_bonus')), 1),
                      (returnBonus.value?.loginsCount === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.$t(`bonuses.return_bonus_day`, {days: returnBonus.value?.loginsCount, percent: returnBonus.value?.percent})), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t(`bonuses.return_bonus_days`, {days: returnBonus.value?.loginsCount, percent: returnBonus.value?.percent})), 1)),
                      _createElementVNode("div", _hoisted_34, [
                        _cache[9] || (_cache[9] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(returnBonus.value?.winSum.amount)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, " Earn extra bonus for every day in a row you come back to play. Max bonus is " + _toDisplayString(returnBonus.value.maxPercent) + "% ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('bonuses.play_bonus')), 1),
                      _createElementVNode("div", _hoisted_39, [
                        (!playBonus.value?.hasBonus)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, "You didn’t play"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_41, "+" + _toDisplayString(playBonus.value?.percent) + "%", 1))
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _cache[10] || (_cache[10] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(playBonus.value?.winSum.amount)), 1)
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "description" }, " Earn extra bonus every day for spinning at least 10 times. ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('bonuses.purchase_bonus')), 1),
                      _createElementVNode("div", _hoisted_45, [
                        (!purchaseBonus.value?.hasBonus)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, "You didn’t purchase"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(purchaseBonus.value?.multiplier), 1))
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _cache[12] || (_cache[12] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(purchaseBonus.value?.winSum.amount)), 1)
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "description" }, " Earn an extra bonus every day for 3 days whenever you stock up on coins in our store. ", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    ref_key: "collectBtnRef",
                    ref: collectBtnRef,
                    onClick: claim,
                    class: "btn btn-primary mt-2"
                  }, _toDisplayString(_ctx.$t('collect_bonus')), 513)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 512))
}
}

})